import { Field, Label, Radio, RadioGroup } from "@headlessui/react";
import clsx from "clsx";
import { Fragment } from "react";

export default function HeadlessRadioGroup({
  name,
  ref,
  value,
  onChangeHandler,
  options,
  errorMsg,
  size = "sm",
  className,
  ...restProps
}) {
  return (
    <RadioGroup className={className} value={value} onChange={onChangeHandler}>
      {options.map((option) => (
        <Field
          key={option.value}
          className="tw-flex tw-items-center tw-gap-2"
          {...restProps}
        >
          <Radio
            as={Fragment}
            value={option.value}
            name={name}
            id={option.value}
          >
            {({ checked, disabled }) => (
              <span
                className={clsx(
                  errorMsg && "tw-border-2 tw-border-error-light",
                  "tw-group tw-cursor-pointer tw-flex tw-items-center tw-justify-center tw-rounded-full tw-border",
                  size === "sm" && "tw-size-6",
                  size === "lg" && "tw-size-9",
                  (checked || option.active) && !disabled
                    ? "tw-bg-primary-light tw-border-none"
                    : "tw-bg-white tw-border tw-border-boarder-light",
                  disabled && "tw-bg-disabled-bg-light tw-border-disabled-text"
                )}
                name={name}
                ref={ref}
                data-testid={`radio-option-${option.value}`}
              >
                {(option.active || checked) && (
                  <span
                    className={clsx(
                      "tw-rounded-full",
                      size === "sm" && "tw-size-2",
                      size === "lg" && "tw-size-3",
                      disabled ? "tw-bg-disabled-text" : "tw-bg-white"
                    )}
                  />
                )}
              </span>
            )}
          </Radio>
          <Label
            className={clsx(
              "data-[disabled]:tw-text-text-disabled tw-text-text-primary-light",
              size === "lg" && "tw-text-lg"
            )}
            htmlFor={option.value}
          >
            {option.label ?? option.value}
          </Label>
        </Field>
      ))}
    </RadioGroup>
  );
}
